import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { TargetAudience } from './components/TargetAudience';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-violet/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Reviews data-id="element-4" />
        <TargetAudience data-id="element-5" />
        <Problem data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonos data-id="element-8" />
        <Comparison data-id="element-9" />
        <Pricing data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}